export const formatPrice = (amount) => {
  // First try WooCommerce's native formatter if available
  if (typeof wc !== "undefined" && wc?.priceFormat?.formatPrice) {
    return wc.priceFormat.formatPrice(amount);
  }

  const {
    currency_symbol,
    decimal_separator,
    thousand_separator,
    decimals,
    price_format,
  } = hs.woocommerce;

  const value = parseFloat(amount).toFixed(decimals);
  const [whole, decimal] = value.split(".");
  const formattedWhole = whole.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    thousand_separator
  );
  const formattedAmount = formattedWhole + decimal_separator + decimal;

  const formattedPrice = price_format
    .replace("%1$s", currency_symbol)
    .replace("%2$s", formattedAmount)
    .replace(/&euro;/g, "€")
    .replace(/&nbsp;/g, " ");

  return formattedPrice;
};
